export const rootStyles = {
  display: 'flex',
  flexDirection: 'column',
  // The parent tab-content wrapper is a block element with a definite (viewport-bounded)
  // height, so height:100% fills it — flex:1 would be a no-op inside a block parent and
  // collapse the workspace to its content height. minHeight:0 lets children scroll.
  height: '100%',
  minHeight: 0,
  position: 'relative',
  '& .view-extraction-fields-button': {
    margin: '5px',
  },
};
